import { snakifyProps } from "@ds/utils/strings";
import { isNumberArray } from "@ds/utils/type-guards/common-guards";

const serializeTableFilter = ({ operator, values }: TableFilterValue) => {
  switch (operator) {
    case "starts":
      return `^${values[0]}`;
    case "is":
      return values[0];
    default:
      return `[${values.join(",")}]`;
  }
};

export const serializeTableFilters = (tableFilters: TableFilters = {}): Record<string, string> =>
  Object.fromEntries(
    Object.entries(tableFilters)
      .filter(([, { values }]) => values.length)
      .map(([field, value]) => [field, serializeTableFilter(value)]),
  );

export const convertToApiQueryInfo = (
  { sortField, sortOrder }: SortingSlice,
  { filters, pattern, tableFilters }: QuerySlice,
): QueryInfo => ({
  sortField,
  sortOrder,
  filters: tableFilters ? ({ ...serializeTableFilters(tableFilters), ...filters } as QueryFilters) : filters,
  pattern,
});

export const normalizeFilters = (obj: Record<string, unknown>) =>
  Object.fromEntries(Object.entries(obj).map(([k, v]) => (isNumberArray(v) ? [k, `[${v.join(",")}]`] : [k, v])));

export const snakifyFilters = (obj: KeysToCamelCase<QueryFilters>): QueryFilters => snakifyProps(obj);
